<template>
  <div class="my-container">
    <div class="right">
      <h1 class="my-title">PRETRAGA PACIJENATA</h1>
      <!-- <v-autocomplete
      v-model="search"
      :loading="patientSearchLoading"
      :items="patients"
      :search-input.sync="searchPatients"
    >
    </v-autocomplete> -->

      <!-- @input="searchPatients" -->
      <v-text-field
        v-model="search"
        class="patient-search-input"
        outlined
        color="teal"
        filled
        placeholder="Unesite ime/prezime pacijenta"
      ></v-text-field>

      <!-- DVE PAGINIACIJE -->
      <!-- <v-pagination
        v-model="page"
        :length="numPages"
        v-if="patients.length"
        class="pagination"
        color="teal lighten-1"
        @input="handlePagination"
      ></v-pagination> -->
      <!-- DVE PAGINIACIJE -->

      <!-- KARTICE -->
      <!-- <div v-if="patients.length !== 0" class="patients-container">
        <div
          v-for="(patient, ind) in patients"
          :key="ind"
          class="selected-patient"
        >
          <patient-card
            :patient="patient"
            :active="currentPatientId === patient.id"
            @clickProfile="selectCurrentPatient(patient)"
          ></patient-card>
        </div>
      </div> -->
      <!-- KARTICE -->

      <patient-list
        v-if="patients.length !== 0"
        :patients="patients"
        @clickProfile="selectCurrentPatient"
      ></patient-list>

      <div v-else class="no-info">
        Nema rezultata za trenutnu pretragu
      </div>

      <!-- </div> -->

      <v-pagination
        v-model="page"
        :length="numPages"
        v-if="patients.length"
        color="teal lighten-1"
        class="pagination"
        @input="handlePagination"
      ></v-pagination>
    </div>
    <div class="patient-info" ref="patientInfoRef">
      <patient-info :patient="currentPatient"></patient-info>
    </div>

    <!-- <v-overlay :value="open" light absolute>
      <v-card light>
        <patient-info :patient="currentPatient"></patient-info>
      </v-card>
    </v-overlay> -->
  </div>
</template>

<script>
// import PatientCard from "./PatientCard.vue";
import PatientInfo from "./PatientInfo.vue";
import PatientList from "./PatientList.vue";
// import { debounce } from "../util";
const NUM_PATIENT_RESULTS = 10;
export default {
  name: "PatientSearch",
  components: { PatientInfo, PatientList },
  data() {
    return {
      patientSearchLoading: false,
      search: null,
      patients: [],
      page: 1,
      numPages: 1,
      currentPatient: {},
      currentPatientId: null,
      //   searchPatients: null,
      open: false,
    };
  },
  mounted: async function() {
    // console.log("caososocoaoas");
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    } else {
      this.page = 1;
    }

    try {
      const res = await this.$http.patients.getAll(
        this.page,
        NUM_PATIENT_RESULTS
      );
      this.patients = res.data.patients;
      this.page = 1;
      this.numPages = Math.ceil(res.data.count / NUM_PATIENT_RESULTS);
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    async searchPatients() {
      //   if (this.patients.length > 0) return;
      if (this.search == "" || !this.search) return;
      if (this.patientSearchLoading) return;
      this.patientSearchLoading = true;
      const curSearch = this.search;
      this.page = 1;
      this.$router.push({
        path: this.$route.fullPath,
        query: { search: curSearch, page: this.page },
      });
      try {
        const first = await this.$http.patients.searchCount(curSearch);
        console.log(first);
        this.numPages = Math.ceil(first.data / NUM_PATIENT_RESULTS);
        const res = await this.$http.patients.search(
          curSearch,
          this.page,
          NUM_PATIENT_RESULTS
        );
        this.patients = res.data;
        console.log("FILTRIRAIRANO", this.filteredPatients);
        this.patientSearchLoading = false;
      } catch (err) {
        console.log(err);
        this.patientSearchLoading = false;
        this.$root.$emit("apiError");
      }
      // console.log("hellooo");
      //   res.data.forEach((patient) => {
      //     patient.text = patient.firstname + " " + patient.lastname;
      //   });
    },
    async handlePagination(num) {
      const curSearch = this.search;
      this.$router.push({
        path: this.$route.fullPath,
        query: { search: curSearch, page: num },
      });
      try {
        let res;
        if (curSearch) {
          res = await this.$http.patients.search(
            curSearch,
            num,
            NUM_PATIENT_RESULTS
          );
          this.patients = res.data;
        } else {
          res = await this.$http.patients.getAll(
            this.page,
            NUM_PATIENT_RESULTS
          );
          this.patients = res.data.patients;
          this.numPages = Math.ceil(res.data.count / NUM_PATIENT_RESULTS);
        }
        console.log("FILTRIRAIRANO", this.filteredPatients);
        this.patientSearchLoading = false;
      } catch (err) {
        console.log(err);
        this.$root.$emit("apiError");
      }
    },
    async selectCurrentPatient(index) {
      // Da bi radila sa karticama, mora da prima pacijenta kao objekat
      console.log({ index });
      const patient = this.patients[index];
      this.currentPatientId = patient.id;
      // const { data } = await this.$http.appointments.getLatestForPatient(
      //   patient.id,
      //   1
      // );
      // console.log(data);
      // this.currentPatient = {};
      // patient.appointment = data.appointments[0];
      this.currentPatient = patient;
      this.open = true;
      this.$refs.patientInfoRef.scrollIntoView({ behavior: "smooth" });
    },
  },
  watch: {
    search() {
      if (this.search) {
        this.searchPatients();
      } else {
        this.handlePagination(1);
      }
    },
  },
  computed: {
    filteredPatients() {
      //return this.patients.splice(this.page - 1, 3);
      // return [
      //   this.patients[(this.page - 1) * 3],
      //   this.patients[(this.page - 1) * 3 + 1],
      //   this.patients[(this.page - 1) * 3 + 2],
      // ];
      return [this.patients[0], this.patients[1], this.patients[2]];
    },
  },
};
</script>

<style scoped>
.right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-start;
  width: 20%;
  height: 80vh;
}
.patients-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: space-evenly;
  width: 100%;
  /* min-height: 100%; */
}

.patient-search-input {
  max-height: 10%;
  margin-bottom: 20px;
}

.my-container {
  display: flex;
  width: 100%;
  /* justify-content: space-between; */
  gap: 15px;
}

.no-info {
  margin-top: 150px;
  text-align: center;
}

.patient-info {
  width: 70%;
}

.selected-patient {
  /* background-color: teal; */
}

.pagination {
  /* margin-top: auto; */
}

.my-title {
  font-size: 1.75em;
}

@media only screen and (max-width: 1000px) {
  .my-container {
    flex-direction: column;
  }
  .right {
    width: 100%;
  }
  .patient-info {
    width: 100%;
  }
}
</style>
